/**
 * @desc 首页
 * @author caoyx
 */
import styles from './index.scss';
import { Button, Form, Select } from 'antd';
import React, { PureComponent } from 'react';
import CompanyAutoComplete from '../../common/companyAutoComplete/CompanyAutoComplete';
import { getOptions } from '../../../services/financialPicture/index';

const FormItem = Form.Item;
const Option = Select.Option;

class Index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            companyName: '',
            companyCode: '',
            optionsData: {}
        };
    }

    // <CompanyAutoComplete />有改动时，判断时候清空之前存储的数据
    autoCompleteChange = () => {
        const { companyName } = this.state;
        const { company } = this.props.form.getFieldsValue();
        if (company !== companyName) {
            this.setState({
                companyName: '',
                companyCode: '',
                optionsData: {}
            });
        }
    };

    /**
     * @desc <CompanyAutoComplete /> 组件回调的方法，用于获取公司信息数据
     * @param {Object} companyInfo 所选公司信息
     */
    getCompanyInfo = companyInfo => {
        const { code, name } = companyInfo;
        this.setState({
            optionsData: {}
        }, () => {
            getOptions({ companyCode: code }).then(optionsData => {
                this.setState({
                    companyName: name,
                    companyCode: code,
                    optionsData
                });
            });
        });
    };

    /**
     * @desc 查询，跳转
     * @param {event} e 事件
     */
    jump = e => {
        e.preventDefault();
        const { companyCode } = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { reportYear, reportType, reportDateType } = values;
                const { origin } = window.location;
                // 先清除缓存的公司信息
                window.open(
                    `${origin}/#/cwhx/sy/gs?companyInfo=${JSON.stringify({
                        companyCode,
                        reportYear,
                        reportType,
                        reportDateType
                    })}`
                );
            }
        });
    };

    render() {
        const { optionsData = {} } = this.state;
        const { reportYear = [], reportType = [], reportDateType = [] } = optionsData;
        const { getFieldDecorator } = this.props.form;

        return (
            <div className={styles.index}>
                <Form className="login-form" layout="inline">
                    <FormItem>
                        <div className={styles.autoCompleteBox}>
                            {getFieldDecorator('company', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入企业相关信息!'
                                    }
                                ]
                            })(
                                <CompanyAutoComplete
                                    clasName={styles.autoComplete}
                                    placeholder="请输入企业名称或者股票代码，如“300156”，神雾环保"
                                    getCompanyInfo={this.getCompanyInfo}
                                    onChange={this.autoCompleteChange}
                                />
                            )}
                        </div>
                    </FormItem>
                    {reportYear.length > 0 && (
                        <div>
                            <FormItem label="财报年份">
                                {getFieldDecorator('reportYear', {
                                    initialValue: reportYear[0]
                                })(
                                    <Select className={styles.antSelect} size="default">
                                        {reportYear.map(item => (
                                            <Option key={item} value={item}>
                                                {item}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem label="财报类型">
                                {getFieldDecorator('reportType', {
                                    initialValue: reportType[0].key
                                })(
                                    <Select className={styles.antSelect} size="default">
                                        {reportType.map(item => (
                                            <Option key={item.key} value={item.key}>
                                                {item.value}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem className={styles.resultsTypeComp}>
                                {getFieldDecorator('reportDateType', {
                                    initialValue: reportDateType[0].key
                                })(
                                    <Select className={styles.antSelect} size="default">
                                        {reportDateType.map(item => (
                                            <Option key={item.key} value={item.key}>
                                                {item.value}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem className={styles.searchBtnItem}>
                                <Button type="primary" icon="search" onClick={this.jump} loading={false}>
                                    查询
                                </Button>
                            </FormItem>
                        </div>
                    )}
                </Form>
                <div />
            </div>
        );
    }
}

export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/financialPicture/index/Index.jsx